import { useTranslation } from "react-i18next";

export const SelectWorkspacePlaceholder = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] space-y-6 animate-fade-in">
      <div className="flex justify-center">
        <img 
          src="/assets/logo.png" 
          alt="Prodgy Logo" 
          className="h-32 w-auto"
        />
      </div>
      <div className="text-center space-y-2 max-w-md px-4">
        <h2 className="text-2xl font-bold tracking-tight">
          {t("common.workspaces.selectWorkspace")}
        </h2>
        <p className="text-muted-foreground">
          {t("common.workspaces.selectWorkspaceDescription")}
        </p>
      </div>
    </div>
  );
};
